const getElement = (elementId) => {
    const id = elementId;
    let element = document.getElementById(id);
    if (element === null) {
        element = document.createElement('div');
        element.id = id;
        document.body.appendChild(element);
    }
    return element;
};
export default getElement;
